
import type { User } from './chat-data';

export const consultants: User[] = [
  {
    id: 'nguyen-quoc-viet',
    name: 'Nguyễn Quốc Việt',
    avatarUrl: '/img/TVV009.JPG',
    dataAiHint: 'professional man portrait',
    experience: '12 năm',
    mainExpertise: 'Tư vấn chiến lược việc làm tại Nhật',
    successfulCandidates: 880,
    strengths: ['Tầm nhìn', 'Chiến lược', 'Kết nối cấp cao', 'Định hướng sự nghiệp'],
    messengerId: 'gu.en.beto.2025',
    zalo: 'https://zalo.me/0902045222',
    phone: '+84902045222',
  },
  {
    id: 'phung-thi-tuyet-nhung',
    name: 'Phùng Thị Tuyết Nhung',
    avatarUrl: '/img/TVV008.png',
    dataAiHint: 'professional woman portrait',
    experience: '8 năm',
    mainExpertise: 'Tư vấn Kỹ sư, Thực tập sinh, Đặc định & Phát triển sự nghiệp',
    successfulCandidates: 420,
    strengths: ['Tận tâm', 'Hỗ trợ toàn diện', 'Đào tạo kỹ năng'],
    messengerId: '61577193914962',
    zalo: 'https://zalo.me/0916033799',
    phone: '+84916033799',
  },
  {
    id: 'le-xuan-long',
    name: 'Lê Xuân Long',
    avatarUrl: '/img/long.jpg',
    dataAiHint: 'professional man portrait',
    experience: '2 năm',
    mainExpertise: 'Tư vấn việc làm Kỹ năng đặc định (Tokutei)',
    successfulCandidates: 185,
    strengths: ['Tận tình', 'Nhiều đơn', 'Hiểu rõ ngành'],
  },
  {
    id: 'nguyen-thi-phuong-loan',
    name: 'Nguyễn Thị Phương Loan',
    avatarUrl: '/img/TVV002.jpg',
    dataAiHint: 'professional woman portrait',
    experience: '2 năm',
    mainExpertise: 'Tư vấn Đặc định và Kỹ sư, tri thức',
    successfulCandidates: 160,
    strengths: ['Nhiệt tình', 'Hỗ trợ 24/7', 'Quan hệ rộng'],
  },
   {
    id: 'nguyen-thi-ngoc-oanh',
    name: 'Nguyễn Thị Ngọc Oanh',
    avatarUrl: '/img/TVV003.png',
    dataAiHint: 'professional woman portrait',
    experience: '5 năm',
    mainExpertise: 'Tư vấn Tokutei Vận tải, Xây dựng, Thực phẩm',
    successfulCandidates: 380,
    strengths: ['Nhiều đơn gấp', 'Hỗ trợ nhiệt tình', 'Kinh nghiệm'],
    messengerId: 'ngocoanhhj',
    zalo: 'https://zalo.me/0936199064',
    phone: '+84936199064',
  },
  {
    id: 'pham-thi-ha',
    name: 'Phạm Thị Hà',
    avatarUrl: '/img/TVV004.png',
    dataAiHint: 'professional woman portrait',
    experience: '4 năm',
    mainExpertise: 'Tư vấn Nhà hàng, Cơ khí, Điều dưỡng, Nông nghiệp',
    successfulCandidates: 320,
    strengths: ['Tận tâm', 'Am hiểu thủ tục', 'Hỗ trợ chi tiết'],
  },
  {
    id: 'dao-quang-minh',
    name: 'Đào Quang Minh',
    avatarUrl: '/img/TVV005.jpg',
    dataAiHint: 'male consultant portrait',
    experience: '1 năm',
    mainExpertise: 'Tư vấn Công xưởng và Ngoài trời',
    successfulCandidates: 95,
    strengths: ['Kinh nghiệm', 'Quan hệ rộng', 'Tỷ lệ đỗ cao'],
  },
  {
    id: 'nguyen-thi-thu-trang',
    name: 'Nguyễn Thị Thu Trang',
    avatarUrl: '/img/TVV006.jpg',
    dataAiHint: 'female consultant smiling',
    experience: '2 năm',
    mainExpertise: 'Tư vấn Thực tập sinh kỹ năng và Đặc định',
    successfulCandidates: 175,
    strengths: ['Nhiệt tình', 'Am hiểu ngành', 'Hỗ trợ nhanh'],
  },
];
